const image_box     = {
    image_box:      <svg
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
  >
    <g xmlns="http://www.w3.org/2000/svg" fill="red">
      <circle cx="316" cy="166" r="15" data-original="#000000"></circle>
      <path
        d="M91 339.789l94.395-94.395c5.859-5.859 15.352-5.859 21.211 0L256 294.789l49.395-49.395c5.859-5.859 15.352-5.859 21.211 0L421 339.789V91H91zM316 121c24.814 0 45 20.186 45 45s-20.186 45-45 45-45-20.186-45-45 20.186-45 45-45z"
        data-original="#000000"
      ></path>
      <path
        d="M266.605 326.605c-5.859 5.859-15.352 5.859-21.211 0L196 277.211 112.211 361h287.578L316 277.211z"
        data-original="#000000"
      ></path>
      <path
        d="M512 74.897C511.941 33.574 478.309 0 437.015 0H74.429C34.79.057-.064 31.688 0 75.586v301.531c.055 37.256 26.845 66.749 60.117 73.418l.073 46.494c0 8.225 6.702 14.971 15 14.971h.029c20.039-.029 38.862-7.866 52.998-22.061 10.532-10.576 17.534-23.745 20.405-38.057l288.933-.322c41.367-.059 74.502-33.75 74.443-75.132V74.897zm-61 301.898c0 8.207-6.727 15-15 15H76c-8.207 0-15-6.727-15-15V75.234c0-8.291 6.709-15 15-15h360c8.291 0 15 6.709 15 15z"
        data-original="#000000"
      ></path>
    </g>
  </svg>
}

export default image_box;